<template>
    <div class="wrapper">
        <div name="home" class="home">
            <patient-info v-if="state === 0" 
                @nextStep="nextStep"
                @onError="onError"
            />
            <card-info v-else-if="state === 1" 
                @nextStep="nextStep"
                @onError="onError"
                @onCardError="onCardError"
            />
            <!-- <booking v-else/> -->
            <page-footer 
                :state="state"
            />
            <error-modal 
                v-if="error !== ''"
                :error="error"
                @onClose="closeModal"
            />
            <card-error-modal 
                v-if="cardError !== ''"
                :error="cardError"
                @onClose="closeModal"
            />
        </div>
    </div>
</template>

<script>
// compnents 3 
// patient info, card info, booking
import PatientInfo from '@/components/organisms/sleepq/PatientInfo';
import CardInfo from '@/components/organisms/sleepq/CardInfo';
import Booking from '@/components/organisms/sleepq/Booking';
import {mapState} from 'vuex';
import Constant from '@/constant';
import PageFooter from '@/components/molecules/PageFooter';
import ErrorModal from '@/components/modals/ErrorModal';
import CardErrorModal from '@/components/modals/CardErrorModal';
import axios from 'axios';
export default {
    name: 'sleepq',
    components: {
        PatientInfo,
        CardInfo,
        Booking,
        PageFooter,
        ErrorModal,
        CardErrorModal
    },
    computed: mapState(['profile', 'agreements', 'card_info']),
    data: function(){
        return {
            state: 0,
            error: '',
            cardError: ''
        }
    },
    mounted: function() {
        this.$store.commit(Constant.INITIALIZE_PROFILE);
        this.$store.commit(Constant.INITIALIZE_AGREEMENTS);
        this.$store.commit(Constant.INITIALIZE_CARD_INFO);
        
    },
    methods: {
        onError: function(error){
            this.error = error;
        },  
        onCardError: function(error)
        {
            this.cardError = error;
        },
        nextStep: function(step)
        {
            if(step === 2)
            {
                this.sendAlimtalk();
                alert("제출이 완료되었습니다.")

                window.location.reload()
                return;
            }
            this.state = step;
        },
        getCurrentDateTimeString: function () {
            const now = new Date();

            const yyyy = now.getFullYear();
            const mm = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
            const dd = String(now.getDate()).padStart(2, '0');
            const hh = String(now.getHours()).padStart(2, '0');
            const min = String(now.getMinutes()).padStart(2, '0');
            const ss = String(now.getSeconds()).padStart(2, '0');

            return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
        },

        sendAlimtalk: async function()
        {
            const url = `https://dbapi.soldoc.co.kr/soldoc/message/send`; 
            var datetime = this.profile.underlying_disease.split(" ");
            const data = {
                name: `${this.profile.name}`,
                birth: `${this.profile.registration_number.substring(0, 6)}`,
                registeredAt: `${this.getCurrentDateTimeString()}`,
                desiredDate: `${datetime[0]}T${datetime[1]}`
            }

            try{
                // 3. 파일 업로드 요청
                const response = await axios.post(url, data);
            }
            catch(error)
            {

            }     
        },
        closeModal: function()
        {
            this.error = '';
            this.cardError = '';
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .home {
        width: 100%;
    }

    @media (min-width: 600px) {
        .home {
            width: 600px;
        }

    }
</style>


// WEBPACK FOOTER //
// src/page/SleepQ.vue